import React from "react";
import { MessageList, Message } from "@chatscope/chat-ui-kit-react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import { useAuth } from "../contexts/AuthContext";
import { Typography } from "@material-ui/core";
import imgBanner from "../assets/4044971.jpg";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  messageFeed: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "90vh",
    textAlign: "center",
    fontSize: "1.2em",
    backgroundImage: `url(${imgBanner})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  },
}));

function MessageFeed({ messages, senders }) {
  const classes = useStyles();
  const { currentUser } = useAuth();
  const getSenderName = (uid) => {
    const found = senders.find((sender) => sender.uid === uid);
    if (found) {
      // console.log(found);
      return found.displayName;
    } else {
      return "[User]";
    }
  };
  return messages.length === 0 ? (
    <MessageList.Content className={classes.messageFeed}>
      <Typography variant="h3">
        {" "}
        this room is kinda empty, start chating{" "}
      </Typography>
    </MessageList.Content>
  ) : (
    messages.map((message, index) => (
      <Message
        key={index}
        model={{
          message: message.content,
          sender: getSenderName(message.senderID, senders),
          sentTime: "just now",
          direction:
            message.senderID === currentUser.uid ? "outgoing" : "incoming",
          position: index === messages.length - 1 ? "last" : "normal",
        }}
      >
        <Message.Header
          sender={getSenderName(message.senderID)}
          sentTime="just now"
        />
      </Message>
    ))
  );
}

export default MessageFeed;
